module.exports = __webpack_public_path__ + "img/profitability2.6efd7059.png";